import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import {Card, Checkbox, Col, Row} from '@deere/ux.uxframe-react';
import styles from './index.css';
import {SpinnerIcon, SuccessIcon} from '../../Icon';
import {DeereFetch} from '../../../shared/fetch';
import TextField from '@material-ui/core/TextField';

export const BulkERegistry = () => {
    const [processing, setProcessing] = useState(false);
    const [bundleNumbers, setBundleNumbers] = useState('');
    const [errorMsg, setErrorMsg] = useState(null);
    const [completed, setCompleted] = useState(false)
    const [bundlesForProcessing, setBundlesForProcessing] = useState(null);
    const [isIncorrectDocumentDownloadFlag, setIsIncorrectDocumentDownloadFlag] = useState(false);

    const processBundles = async () => {
        return await DeereFetch('/api/esign/eregistry/xml/bulk', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({
                'bundleNumbers': bundleNumbers,
                'incorrectDocumentDownloadFlag': isIncorrectDocumentDownloadFlag
            })
        });
    }

    const onProcessButtonClick = () => {
        setProcessing(true);
        setCompleted(false)
        processBundles()
            .then((response) => {
                response && setBundlesForProcessing(response)
            })
            .catch((err) => {
                setErrorMsg(`An error occured: ${err.status} ${err.error} ${err.message}`)
            })
            .finally(() => {
                setCompleted(true);
                setProcessing(false);
            })
    }

    const handleChange = (e) => {
        setBundleNumbers(e.target.value)
    }

    const handleCheckboxChange = (e) => {
        setIsIncorrectDocumentDownloadFlag(e.target.checked)
    }

    const componentMap = {
        [completed && errorMsg === null]:
    <p className={styles.success}>
        <SuccessIcon className="success" size="18%"/>
        <span className="d-block mt-20">COMPLETED</span>
    </p>,
        [completed && errorMsg !== null]:
    <p className={styles.failed}>
        {errorMsg}
    </p>
    }

    return (
        <Card>
            <Card.Body>
                <Row>
                    <Col>
                        <div className={styles.header}>
                            Bulk E-Registry XML Generation Utility
                        </div>
                    </Col>
                    <Col>
                        <TextField
                            id="quote-number"
                            margin="none"
                            multiline={true}
                            onChange={handleChange}
                            placeholder="B123456,B234567"
                            value={bundleNumbers}
                        />
                    </Col>
                    <Col>
                        Is this process for Incorrect Document Download Issue?
                        <Checkbox
                            id={'isIncorrectDocumentDownloadIssueCheckbox'}
                            onChange={e => handleCheckboxChange(e)}
                        />
                    </Col>
                    <Col>
                        {
                            processing ?
                                <SpinnerIcon size="md"/> :
                                <Button
                                    color="primary"
                                    onClick={() => onProcessButtonClick()}
                                    size="large"
                                    variant="contained"
                                >PROCESS
                                </Button>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {componentMap.true}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {bundlesForProcessing && bundlesForProcessing.length !== 0 && <span className="d-block mt-20"><strong>Bundles For Processing:</strong> {bundlesForProcessing.join(' ')}</span>}
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};
